import { createContext, useEffect, useState } from "react";
import { getErrorMessageFromError } from "../../components/ErrorMessage";
import { useApp } from "../../hooks/useApp";
import { LeadTagDto } from "../../model/LeadTagDto";
import { SVLeadTagRequest, SVLeadTagDelete, SVLeadTagSaveRequest, SVLeadTagUpdatedRequest } from "../../services/leadTag/LeadTagService";

const LeadTagDataContext = createContext();

const LeadTagDataContextProvider = ({ children }) => {
    const [listLeadTag, setListLeadTag] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedLeadTag, setSelectedLeadTag] = useState(null);
    const [leadTagIdToDelete, setLeadTagIdToDelete] = useState(0);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

    const { setSuccessMsg,
        setErrorMsg,
        setLoading,
        messageUser,
        loading,
        authenticate,
        authInfo,
        isAdmin,
    } = useApp();
    const [isFirstRenderRowsPerPage, setIsFirstRenderRowsPerPage] = useState(true);
    const [page, setPage] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    
    const handleChangePage = (event, newPage) => {
        setPage(newPage);        
    };
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
    };

    useEffect(() => {
        if(authenticate,authInfo)
            setTimeout(
                () => loadLeadTag(), 
                100
            );
    },[page]);

    useEffect(() => {
        if(isFirstRenderRowsPerPage)
            setIsFirstRenderRowsPerPage(false);
        else{
            if(page == 0)
                setTimeout(
                    () => loadLeadTag(), 
                    100
                );
            else
                setPage(0);
        }
    },[rowsPerPage]);

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedLeadTag(null)
    };

    const onClickActionEditButton = (params) => {
        setSelectedLeadTag(params.row);
        handleOpenModal()
    };

    const handleFormSubmit = async (values) => {
        try {
            const input = {
                ...values
            };
            setLoading(true)
            if (values.id) {
                await SVLeadTagUpdatedRequest(input);
                setSuccessMsg("Editado con éxito");

            } else {
                await SVLeadTagSaveRequest(input);
                setSuccessMsg("Creado con éxito")
            }
            loadLeadTag();
            setLoading(false);
            handleCloseModal();
        } catch (error) {
            let errorMessage = getErrorMessageFromError(error);
            if (!errorMessage) {
                errorMessage = "Error desconocido al procesar la solicitud";
            }
            setErrorMsg(errorMessage);
            setLoading(false);
        }
    }

    const loadLeadTag = async () => {
        // console.log("desde contexts");
        try {
            setLoading(true);
            let responseLeadTagList = await SVLeadTagRequest(page, rowsPerPage);
            setTotalItems(responseLeadTagList.totalElements);
            const leadTag = responseLeadTagList.content.map(leadTagData => {
                return new LeadTagDto(
                    leadTagData.factor_id,
                    leadTagData.name
                );
            })
            setListLeadTag(leadTag)
            setLoading(false)
        } catch (error) {
            setLoading(false)
            const errorMessage = getErrorMessageFromError(error);
            setErrorMsg(errorMessage)
            setLoading(false);
        }
    }

    const openDeleteConfirmation = (leadTagId) => {
        setLeadTagIdToDelete(leadTagId);
        setShowDeleteConfirmation(true);
    };

    const closeDeleteConfirmation = () => {
        setLeadTagIdToDelete(null);
        setShowDeleteConfirmation(false);
    };

    const handleDeleteConfirmed = async () => {
        closeDeleteConfirmation();
        if (leadTagIdToDelete) {
            await handleDelete(leadTagIdToDelete);
        }
    };

    const handleDelete = async (leadTagId) => {
        try {
            setLoading(true)
            await SVLeadTagDelete(leadTagId);
            setSuccessMsg("Eliminado con éxito")
            loadLeadTag();
            setLoading(false)
        } catch (error) {
            let errorMessage = getErrorMessageFromError(error);
            if (!errorMessage) {
                errorMessage = "Error desconocido al procesar la solicitud";
            }
            setErrorMsg(errorMessage);
            setLoading(false);
        }
    };

    return (
        <LeadTagDataContext.Provider value={{
            listLeadTag,
            loadLeadTag,
            loading,
            messageUser,
            handleOpenModal,
            handleCloseModal,
            isModalOpen,
            onClickActionEditButton,
            setSelectedLeadTag,
            selectedLeadTag,
            showDeleteConfirmation,
            openDeleteConfirmation,
            closeDeleteConfirmation,
            handleDeleteConfirmed,
            handleFormSubmit,
            handleDelete,
            page, 
            setPage,
            rowsPerPage, 
            handleChangePage,
            handleChangeRowsPerPage,
            totalItems
        }}>
            {children}
        </LeadTagDataContext.Provider>
    )
}

export { LeadTagDataContext,LeadTagDataContextProvider };
